module.exports = __webpack_public_path__ + "img/Platform_Gradients-10.be2c698b.jpg";